
import {
    CLEAR,
    CHANGE_VIEW,
    INIT_PROJECT,
    SET_LAYER_VISIBILITY,
    ADD_COMMAND,
    REMOVE_COMMAND,
    SET_TEMP_FEATURE,
    SET_TOOLS_MODE
} from '../sagas/map';

import { DEFAULT, getTools as getToolsForMode } from './toolsMode';

const initialState = {
    definition: null,
    center: null,
    resolution: null,
    rotation: null,
    zoom: null,
    layers: [],
    groups: [],
    toolsMode: DEFAULT,
    commands: {
        lastUsedId: 0,
        list: []
    }
};

function addCommand(state, name, params) {
    let lastUsedId = state.commands.lastUsedId + 1;
    return {
        lastUsedId: lastUsedId,
        list: [
            ...state.commands.list,
            {
                id: lastUsedId,
                name,
                params
            }
        ]
    };
}

function removeCommand(state, id) {
    return {
        ...state.commands,
        list: state.commands.list.filter(item => {
            return (item.id !== id);
        })
    }
}

function getGroupsFromMapProject(mapProject) {
    return mapProject.virtualLayerGroups.map(item => {
        return {
            ...item
        };
    });
}

export function getLayer(state, id) {
    return state.layers.reduce((previous, current) => {
        return (current.id === id)
            ? current
            : previous;
    }, null);
}

export function getLayers(state) {
    return state.layers;
}

function getLayersFromMapProject(mapProject) {
    return mapProject.virtualLayers.map(item => {
        return {
            ...item,
            visible: (mapProject.defaultVisibleLayers.indexOf(item.id) !== -1)
        };
    });
}

export function getTools(state, options) {
    return getToolsForMode(state.toolsMode, options);
}

export function getToolsMode(state) {
    return state ? state.toolsMode : null;
}

function setLayerVisibility(layers, id, visible) {
    return layers.map(item => {
        return (item.id === id)
            ? {
                ...item,
                visible: visible
            }
            : {
                ...item
            };
    });
}

export function getTempFeature(state) {
    return state.tempFeature;
}

export default function map(state = initialState, action) {
    switch (action.type) {

        case CLEAR:
            return {
                ...state
            };

        case CHANGE_VIEW:
            return {
                ...state,
                center: action.center || state.center,
                zoom: action.zoom || state.zoom,
                rotation: action.rotation || state.rotation,
                resolution: action.resolution || state.resolution
            };

        case ADD_COMMAND:
            return {
                ...state,
                commands: addCommand(state, action.name, action.params)
            };

        case REMOVE_COMMAND:
            return {
                ...state,
                commands: removeCommand(state, action.id)
            }

        case INIT_PROJECT:
            return {
                ...state,
                definition: action.mapProject,
                rotation: state.rotation || action.mapProject.rotation || 0,
                layers: getLayersFromMapProject(action.mapProject),
                groups: getGroupsFromMapProject(action.mapProject)
            };

        case SET_LAYER_VISIBILITY:
            return {
                ...state,
               layers: setLayerVisibility(state.layers, action.id, action.visibility)
            };

        case SET_TEMP_FEATURE:
            return {
                ...state,
                tempFeature: action.feature
            };

        case SET_TOOLS_MODE:
            return {
                ...state,
                toolsMode: action.toolsMode
           };

        default:
            return state
    }
}
